module.exports = __webpack_public_path__ + "img/wxerweima.b988e246.jpg";